<template>
    <v-row align-md="center">
        <v-col cols="12" md="auto" class="mb-10 mb-md-0">
            <v-badge floating dot>
                <h4 class="tit--sm line-height-1">미팅 관리</h4>
            </v-badge>
        </v-col>
        <v-spacer />
        <v-col cols="12" md="auto">
            <v-btn-toggle v-model="query.state" borderless class="ml-n4 flex-wrap flex-sm-nowrap justify-end" style="overflow: hidden" @change="search">
                <v-btn :to="$route.query.state ? { query: { ...$route.query, state: [] } } : { query: $route.query }" exact text color="grey-6" height="auto" @click.prevent.stop.capture="((query.state = null) || true) && search()">
                    <v-simple-checkbox :value="!query.state" color="primary" />
                    <span class="font-weight-regular">전체보기</span>
                </v-btn>
                <v-btn v-for="{ text, value } in states" :key="text" v-bind="{ value }" exact text color="grey-6" height="auto">
                    <v-simple-checkbox :value="value == query.state" color="primary" @click.stop="toggle(value)" />
                    <span class="font-weight-regular">{{ text }}</span>
                </v-btn>
            </v-btn-toggle>
            <!-- <v-btn-toggle v-model="query.state" borderless class="v-sheet--outlined rounded-0" style="overflow: hidden" @change="search">
                <v-btn :to="$route.query.state ? { query: { ...$route.query, state: [] } } : { query: $route.query }" exact active-class="primary white--text" @click.prevent.stop.capture="((query.state = null) || true) && search()">전체</v-btn>
                <v-btn v-for="{ text, value } in states" :key="text" v-bind="{ value }" exact active-class="primary white--text">{{ text }}</v-btn>
            </v-btn-toggle> -->
        </v-col>
    </v-row>
</template>

<script>
import { attrs_input, MEETING_STATES } from "@/assets/variables";

const states = Object.values(MEETING_STATES);

const initQuery = () => ({
    state: [],
});

export default {
    props: {
        loading: { type: Boolean, default: false },
    },
    data: () => ({
        query: initQuery(),

        states,
        attrs_input,
    }),
    mounted() {
        this.sync();
    },
    watch: {
        $route() {
            this.sync();
        },
    },
    methods: {
        sync() {
            this.query = {
                state: this.$route.query?.state || null,
            };
        },
        toggle(value) {
            let isSame = this.query.state == value;
            this.query.state = isSame ? null : value;
            this.$nextTick(this.search);
        },
        search() {
            let { ...query } = this.query;

            if (!query.state) delete query.state;

            delete query.page;

            this.$router.push({ query });
        },
    },
};
</script>

<style lang="scss" scoped>
</style>
